import { Injectable } from '@angular/core';
import {
  AddProductToCartInput,
  AddProductToCartMutation,
  ClaimPromoCodeInput,
  ClaimPromoCodeMutation,
  LoadShoppingCartQuery,
  UpdateAddressMutation,
  UpdateCartItemInput,
  UpdateCartItemMutation,
  UpdateShippingInformationMutation,
  UpdateShoppingCartAddressInput,
  UpdateShoppingCartShippingInformationInput
} from '@queries/generated';
import { finalMap } from '@rx/final-map';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ShoppingCartService {
  private shoppingCart = this.loadShoppingCart.watch();

  items$ = this.shoppingCart.valueChanges.pipe(map(({ data }) => data.shoppingCart?.cartItems));
  shoppingCart$ = this.shoppingCart.valueChanges.pipe(map(({ data }) => data.shoppingCart));

  constructor(
    private addProductToCart: AddProductToCartMutation,
    private updateCart: UpdateCartItemMutation,
    private claimPromoCode: ClaimPromoCodeMutation,
    private loadShoppingCart: LoadShoppingCartQuery,
    private updateAddressMutation: UpdateAddressMutation,
    private updateShippingInfoMutation: UpdateShippingInformationMutation
  ) {}

  addToCart(input: AddProductToCartInput) {
    return this.addProductToCart.mutate({ input }).pipe(
      map(({ data }) => data.addProductToCart),
      finalMap('shoppingCart')
    );
  }

  refresh() {
    this.shoppingCart.refetch();
  }

  updateCartItem(input: UpdateCartItemInput) {
    return this.updateCart.mutate({ input }).pipe(
      map(({ data }) => data.updateCartItem),
      finalMap('shoppingCart')
    );
  }

  claimPromoCodes(input: ClaimPromoCodeInput) {
    return this.claimPromoCode.mutate({ input }).pipe(
      map(({ data }) => data.claimPromoCode),
      finalMap('shoppingCart')
    );
  }

  updateAddress(input: UpdateShoppingCartAddressInput) {
    return this.updateAddressMutation.mutate({ input }).pipe(
      map(({ data }) => data.updateShoppingCartAddress),
      finalMap('shoppingCart')
    );
  }

  updateShippingInformation(input: UpdateShoppingCartShippingInformationInput) {
    return this.updateShippingInfoMutation.mutate({ input }).pipe(
      map(({ data }) => data.updateShoppingCartShippingInformation),
      finalMap('shoppingCart')
    );
  }
}
